import React, { useEffect, useState } from "react";
import MainPageComponent from "./main.page";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {AccessRights} from "lib/constants/accessRights";
import LoadingComponent from "components/loading";
import { INVENTORY_LIST_PAGE } from "modules/stockflow/config/stockflow.route";
import qs from "query-string";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function MainPageContainer() {
  const canViewBranchInventory = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.BRANCH_INVENTORY));
  const canViewDealerInventory = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.DEALER_INVENTORY));
  const canViewBranchSummary = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.BRANCH_SUMMARY));
  const canViewDealerSummary = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.DEALER_SUMMARY));
  const canViewPackage = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.PACKAGE));
  const canViewBoxes = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.BOXES));
  const canViewLooseItem = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.LOOSE_ITEM));

  const lang = useSelector((state) => state.constant.languages);
  const history = useHistory();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeSummaryIndex, setActiveSummaryIndex] = useState(null);

  const qsParams = qs.parse(location.search);
  const currentSearch = qsParams.type || "";
  const currentSummary = qsParams.summary || "";

  useEffect(() => {
    if (![
      canViewBranchInventory,
      canViewDealerInventory,
      canViewBranchSummary,
      canViewDealerSummary,
      canViewPackage,
      canViewBoxes,
      canViewLooseItem,
    ].some(Boolean)) {
      history.push("/admin/dashboard");
    }
  }, [history, canViewBranchInventory, canViewDealerInventory, canViewBranchSummary, canViewDealerSummary, canViewPackage, canViewBoxes, canViewLooseItem]);

  let index = 0;
  const tabs = [];
  if ([
    canViewBranchInventory,
    canViewDealerInventory,
    canViewBranchSummary,
    canViewDealerSummary,
  ].some(Boolean)) tabs.push({ label: 'product', value: index++ });
  if (canViewPackage) tabs.push({ label: 'package', value: index++ });
  if (canViewBoxes) tabs.push({ label: 'box', value: index++ });
  if (canViewLooseItem) tabs.push({ label: 'loose-item', value: index++ });

  useEffect(() => {
    const tempIndex = tabs.findIndex(tab => tab.label === currentSearch);
    setActiveIndex(tempIndex !== -1 ? tempIndex : 0);
  }, [currentSearch, tabs]);
  
  useEffect(() => {
    let tempIndex = 0;
    switch (currentSearch) {
      case "product":
        tempIndex = 0;
        break;
      case "package":
        tempIndex = 1;
        break;
      case "box":
        tempIndex = 2;
        break;
      case "loose-item":
        tempIndex = 3;
        break;
      default:
        tempIndex = 0;
    }
    setActiveIndex(tempIndex);
  }, [currentSearch]);

  useEffect(() => {
    let tempIndex = 0;
    switch (currentSearch) {
      case "product":
        tempIndex = 0;
        break;
      case "package":
        tempIndex = 1;
        break;
      case "box":
        tempIndex = 2;
        break;
      case "loose-item":
        tempIndex = 3;
        break;
      default:
        tempIndex = 0;
    }
    setActiveIndex(tempIndex);
  }, [currentSearch]);

  useEffect(() => {
    let tempIndex = 0;
    switch (currentSummary) {
      case "to-branch":
        tempIndex = 0;
        break;
      case "to-dealer":
        tempIndex = 1;
        break;
      case "by-branch":
        tempIndex = 2;
        break;
      case "by-dealer":
        tempIndex = 3;
        break;
      default:
        tempIndex = 0;
    }
    setActiveSummaryIndex(tempIndex);
  }, [currentSummary]);


  if (![
    canViewBranchInventory,
    canViewDealerInventory,
    canViewBranchSummary,
    canViewDealerSummary,
    canViewPackage,
    canViewBoxes,
    canViewLooseItem,
  ].some(Boolean)) return <LoadingComponent />;

  let tabLabels = [];
  if ([
    canViewBranchInventory,
    canViewDealerInventory,
    canViewBranchSummary,
    canViewDealerSummary,
  ].some(Boolean)) tabLabels.push(getLang(lang, "label.PRODUCT_TAB"));
  if (canViewPackage) tabLabels.push(getLang(lang, "label.PACKAGE_TAB"));
  if (canViewBoxes) tabLabels.push(getLang(lang, "label.BOX_TAB"));
  if (canViewLooseItem) tabLabels.push(getLang(lang, "label.LOOSE_ITEM_TAB"));

  const handleChange = (event, index) => {
    setActiveIndex(index);
    history.replace({
      pathname: INVENTORY_LIST_PAGE,
      search: `?type=${
        index === 0
          ? "product"
          : index === 1
          ? "package"
          : index === 2
          ? "box"
          : "loose-item"
      }`,
    });
  };

  return (
    <>
      <MainPageComponent
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        activeSummaryIndex={activeSummaryIndex}
        lang={lang}
      />
    </>
  );
}

export default MainPageContainer;
